import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AlertsvarService } from '../../alertsvar.service';

@Component({
  selector: 'app-force-continue',
  templateUrl: './force-continue.component.html',
  styleUrls: ['./force-continue.component.scss']
})
export class ForceContinueComponent implements OnInit {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
   public alertvarservice: AlertsvarService,
    private ref:MatDialogRef<ForceContinueComponent>,
  ){}
  ngOnInit():void {

  }
  terminate_session_alert(){
    this.ref.close(true);
  }
  cancel(){
    this.ref.close(false);
  }


}
